<template>
  <div
    class="sidearm-mm-game-stats minh-100 flex flex-column flex-align-stretch flex-justify-end"
  >
    <div class="px-4 pt-7 pb-2 sidearm-mm-game-stats__title">
      <h3 class="type-hero ma-0">{{ round.title }} Matchup</h3>
    </div>
    <div class="sidearm-mm-game-stats__accordions">
      <accordion>
        <template v-slot:button>
          Team Stats
        </template>
        <div>
          <div class="flex flex-align-center flex-justify-end pa-2">
            <div
              class="sidearm-mm-game-stats__legend flex flex-align-center mr-2"
            >
              <img
                :src="$root.school_logo(36, 36)"
                :alt="
                  $root.data.school.name
                    ? $root.data.school.name
                    : 'School Logo'
                "
              />
              <span class="ml-2 sidearm-mm-game-stats__legend-key"></span>
            </div>
            <div class="sidearm-mm-game-stats__legend flex flex-align-center">
              <img
                :src="
                  round.game.opponent &&
                  round.game.opponent.image &&
                  round.game.opponent.image.url
                    ? `${$root.absolutize_cdn(
                        round.game.opponent.image.url
                      )}?width=36&height=36`
                    : `${$root.school_logo(36, 36)}&s.grayscale=100`
                "
                :alt="
                  round.game.opponent
                    ? round.game.opponent.title
                    : 'Opponent Logo'
                "
              />
              <span
                class="ml-2 sidearm-mm-game-stats__legend-key sidearm-mm-game-stats__legend-key--opponent"
              ></span>
            </div>
          </div>
          <div class="flex flex-wrap">
            <div
              class="sidearm-mm-game-stats__group flex flex-align-center flex-justify-end"
            >
              <div class="sidearm-mm-game-stats__group-title">
                <abbr
                  title="Field Goal Percentage"
                  class="text-bold text-decoration-none border-none"
                  >FG%</abbr
                >
              </div>
              <div
                v-if="$root.cumestats_overall"
                class="flex flex-column flex-align-center flex-justify-center  text-center sidearm-mm-game-stats__chart"
              >
                <abbr
                  title="Field Goal Percentage"
                  class="mb-1 text-decoration-none border-none"
                  >FG%</abbr
                >

                <circle-chart
                  :percentage="
                    Number($root.cumestats_overall.our_field_goal_percentage) *
                      100
                  "
                />
              </div>

              <div
                v-if="round.opponent_stats.team_stats"
                class="flex flex-column flex-align-center flex-justify-center  text-center sidearm-mm-game-stats__chart"
              >
                <abbr
                  title="Field Goal Percentage"
                  class="mb-1 text-decoration-none border-none"
                  >FG%</abbr
                >

                <circle-chart
                  :percentage="
                    Number(
                      round.opponent_stats.team_stats.our_field_goal_percentage
                    ) * 100
                  "
                  color="#D1D1D1"
                />
              </div>
            </div>
            <div
              class="sidearm-mm-game-stats__group flex flex-align-center flex-justify-end"
            >
              <div class="sidearm-mm-game-stats__group-title">
                <abbr
                  title="3 Point Field Goal Percentage"
                  class="text-bold text-decoration-none border-none"
                  >3PT%</abbr
                >
              </div>
              <div
                v-if="$root.cumestats_overall"
                class="flex flex-column flex-align-center flex-justify-center  text-center sidearm-mm-game-stats__chart"
              >
                <abbr
                  title="3 Point Field Goal Percentage"
                  class="mb-1 text-decoration-none border-none"
                  >3PT%</abbr
                >

                <circle-chart
                  :percentage="
                    Number(
                      $root.cumestats_overall
                        .our_three_point_field_goal_percentage
                    ) * 100
                  "
                />
              </div>
              <div
                v-if="round.opponent_stats.team_stats"
                class="flex flex-column flex-align-center flex-justify-center  text-center sidearm-mm-game-stats__chart"
              >
                <abbr
                  title="3 Point Field Goal Percentage"
                  class="mb-1 text-decoration-none border-none"
                  >3PT%</abbr
                >

                <circle-chart
                  :percentage="
                    Number(
                      round.opponent_stats.team_stats
                        .our_three_point_field_goal_percentage
                    ) * 100
                  "
                  color="#D1D1D1"
                />
              </div>
            </div>
            <div
              class="sidearm-mm-game-stats__group flex flex-align-center flex-justify-end"
            >
              <div class="sidearm-mm-game-stats__group-title">
                <abbr
                  title="Free Throw Percentage"
                  class="text-bold text-decoration-none border-none"
                  >FT%</abbr
                >
              </div>
              <div
                v-if="$root.cumestats_overall"
                class="flex flex-column flex-align-center flex-justify-center  text-center sidearm-mm-game-stats__chart"
              >
                <abbr
                  title="Free Throw Percentage"
                  class="mb-1 text-decoration-none border-none"
                  >FT%</abbr
                >

                <circle-chart
                  :percentage="
                    Number($root.cumestats_overall.our_free_throws_percentage) *
                      100
                  "
                />
              </div>
              <div
                v-if="round.opponent_stats.team_stats"
                class="flex flex-column flex-align-center flex-justify-center  text-center sidearm-mm-game-stats__chart"
              >
                <abbr
                  title="Free Throw Percentage"
                  class="mb-1 text-decoration-none border-none"
                  >FT%</abbr
                >

                <circle-chart
                  :percentage="
                    Number(
                      round.opponent_stats.team_stats.our_free_throws_percentage
                    ) * 100
                  "
                  color="#D1D1D1"
                />
              </div>
            </div>
          </div>

          <table class="sidearm-mm-table sidearm-mm-game-stats__table-mobile">
            <tbody>
              <template v-for="stat in team_stats">
                <tr :key="stat.title + '_team'" class="border-none">
                  <th
                    rowspan="1"
                    scope="row"
                    class="border-light-t sidearm-mm-game-stats__table-header"
                  >
                    {{ stat.title }}
                  </th>
                  <th scope="row" class="is-hidden">
                    {{ $root.data.school.name }}
                  </th>
                  <td class="no-padding border-light-t text-left">
                    <span class="sidearm-mm-game-stats__table-stat">{{
                      stat.team
                    }}</span>
                  </td>
                  <td class="no-padding border-light-t text-left">
                    <span
                      v-if="stat.opponent"
                      class="sidearm-mm-game-stats__table-stat"
                      >{{ stat.opponent }}</span
                    >
                  </td>
                </tr>
              </template>
            </tbody>
          </table>

          <table class="sidearm-mm-table  sidearm-mm-game-stats__table-tablet">
            <tbody>
              <template v-for="stat in team_stats">
                <tr :key="stat.title + '_team'" class="border-none">
                  <th
                    :rowspan="stat.opponent !== null ? 2 : 1"
                    scope="row"
                    class="border-light-b"
                  >
                    {{ stat.title }}
                  </th>
                  <th scope="row" class="is-hidden">
                    {{ $root.data.school.name }}
                  </th>
                  <td class="no-padding">{{ stat.team }}</td>
                  <td class="no-padding w-40">
                    <meter
                      v-if="stat.opponent !== null"
                      :value="
                        (stat.team * 100) / (stat.team + Number(stat.opponent))
                      "
                      min="0"
                      max="100"
                      class="sidearm-mm-meter --primary"
                    ></meter>
                  </td>
                  <td
                    class="sidearm-mm-game-stats__table-indicator-column border-light-b"
                    :rowspan="stat.opponent !== null ? 2 : 1"
                  >
                    <span
                      v-if="stat.opponent && stat.team > stat.opponent"
                      class="sidearm-mm-indicator --success"
                    ></span>
                  </td>
                </tr>
                <tr
                  v-if="stat.opponent !== null"
                  :key="stat.title + '_opponent'"
                  class="border-none"
                >
                  <th scope="row" class="is-hidden border-light-b">
                    {{
                      round.opponent
                        ? this.$root.shorten_name(round.opponent.title)
                        : ""
                    }}
                  </th>
                  <td class="no-padding border-light-b">
                    {{ Number(stat.opponent) }}
                  </td>
                  <td class="no-padding w-40 border-light-b">
                    <meter
                      :value="
                        (stat.opponent * 100) /
                          (stat.team + Number(stat.opponent))
                      "
                      min="0"
                      max="100"
                      class="sidearm-mm-meter"
                    ></meter>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </accordion>
      <accordion>
        <template v-slot:button>
          Player Stats
        </template>
        <div>
          <div class="sidearm-mm-game-stats__player-stats h-100 overflow-auto">
            <div class="flex py-2 flex-justify-end flex-align-center">
              <ul
                class="sidearm-mm-game-stats__player-stats__stat-filters reset flex flex-align-center"
              >
                <li
                  v-for="stat in stat_filters"
                  :key="stat.abbreviation"
                  :class="{
                    'is-toggled': stat.abbreviation === active_stat.abbreviation
                  }"
                  class="flex flex-align-center"
                >
                  <button
                    :class="{
                      'is-toggled':
                        stat.abbreviation === active_stat.abbreviation
                    }"
                    :aria-label="
                      `Toggle stat leaders in ${stat.title.toLowerCase()}`
                    "
                    type="button"
                    @click="change_active_stat(stat)"
                  >
                    <abbr
                      :title="stat.name"
                      class="text-uppercase text-bold text-decoration-none"
                      >{{ stat.abbreviation }}</abbr
                    >
                  </button>
                </li>
              </ul>
            </div>

            <table
              class="sidearm-mm-table sidearm-mm-game-stats__table"
              :class="{ 'is-changing': stat_is_changing }"
              v-if="sorted_players && sorted_players.length"
            >
              <thead class="is-hidden">
                <tr class="border-none">
                  <th scope="col">Player</th>
                  <th scope="col">Name</th>
                  <th scope="col">Stat Value</th>
                  <th scope="col">Player Details</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="player in sorted_players"
                  :key="player.rp_id"
                  class="sidearm-mm-game-stats__player-stats__tr relative"
                >
                  <th
                    scope="row"
                    class="sidearm-mm-game-stats__player-stats-headshot"
                  >
                    <div
                      class="flex flex-align-center flex-justify-between pl-1"
                    >
                      <div
                        class="sidearm-mm-game-stats__player-stats__team-logo"
                      >
                        <img
                          :src="
                            player.is_opponent
                              ? round.game.opponent &&
                                round.game.opponent.image &&
                                round.game.opponent.image.url
                                ? `${$root.absolutize_cdn(
                                    round.game.opponent.image.url
                                  )}?width=36&height=36`
                                : `${$root.school_logo(36, 36)}&s.grayscale=100`
                              : $root.school_logo(36, 36)
                          "
                          :alt="
                            player.is_opponent
                              ? round.game.opponent && round.game.opponent.title
                                ? round.game.opponent.title
                                : 'Opponent Logo'
                              : $root.data.school.name
                              ? $root.data.school.name
                              : 'School Logo'
                          "
                        />
                      </div>
                      <div
                        v-if="player && player.image && player.image.url"
                        class="sidearm-mm-game-stats__player-stats__player-image-container relative"
                      >
                        <img
                          :src="
                            `${$root.absolutize_cdn(
                              player.image.url
                            )}?width=120&height=120&mode=crop&format=jpg&quality=80&anchor=topcenter`
                          "
                          :alt="player.name"
                        />
                      </div>
                    </div>
                  </th>
                  <td>
                    <div
                      class="sidearm-mm-game-stats__player-stats__player-name type-paragraph"
                    >
                      <span class="hide-on-medium-down"
                        >{{ player.first_name }}
                      </span>
                      <span class="hide-on-large"
                        >{{ player.first_name.substring(0, 1) }}
                      </span>
                      <span class="text-bold"> {{ player.last_name }}</span>
                    </div>
                  </td>

                  <td class="shrink type-hero-small-plain">
                    {{ player.cumestats[active_stat.individual_stat_key] }}
                  </td>

                  <td colspan="2" class="no-padding">
                    <button
                      @click="open_player_card(player, 2)"
                      class="sidearm-mm-game-stats__player-stats__player-card-toggle"
                    >
                      <span class="type-hero-small-plain mx-4"
                        >View Player Card</span
                      >
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <player-card
              v-model="player_card_open"
              :player-id="player_card_player_id"
              :team-id="player_card_team_id"
              :player="player_card_player"
            >
              <ul
                class="sidearm-mm-player-card__roster reset flex flex-justify-end"
              >
                <li
                  v-for="player in sorted_players"
                  :key="player.rp_id"
                  class="sidearm-mm-player-card__roster-player my-2 flex flex-align-center"
                  :class="{ active: player.rp_id === player_card_player.rp_id }"
                >
                  <button
                    type="button"
                    :aria-label="'Toggle stats for ' + player.name"
                    class="sidearm-mm-player-card__roster-player-toggle"
                    @click="open_player_card(player, 2)"
                  >
                    <img
                      :src="
                        player && player.image && player.image.url
                          ? player.image.url +
                            '?width=60&height=60&mode=crop&format=jpg&quality=80&anchor=topcenter'
                          : player.is_opponent
                          ? round.game.opponent &&
                            round.game.opponent.image &&
                            round.game.opponent.image.url
                            ? `${$root.absolutize_cdn(
                                round.game.opponent.image.url
                              )}?width=60&height=60`
                            : `${$root.school_logo(60, 60)}&s.grayscale=100`
                          : $root.school_logo(60, 60)
                      "
                      :alt="
                        player.is_opponent
                          ? round.game.opponent && round.game.opponent.title
                            ? round.game.opponent.title
                            : 'Opponent Logo'
                          : $root.data.school.name
                          ? $root.data.school.name
                          : 'School Logo'
                      "
                    />
                  </button>
                </li>
              </ul>
            </player-card>
          </div>
        </div>
      </accordion>
      <accordion
        v-if="
          $root.data &&
            $root.data.history_section &&
            $root.data.history_section.items &&
            $root.data.history_section.items.length > 0
        "
      >
        <template v-slot:button>
          Tournament History
        </template>
        <div>
          <table class="sidearm-mm-table">
            <thead>
              <tr>
                <th scope="col">Tournament History</th>
                <th
                  scope="col"
                  aria-label="Tournament History Fact"
                  class="text-center"
                >
                  <div>
                    <img
                      :src="$root.school_logo(36, 36)"
                      :alt="
                        $root.data.school.name
                          ? $root.data.school.name
                          : 'School Logo'
                      "
                    />
                  </div>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="(item, item_index) in $root.data.history_section.items"
                :key="item_index"
              >
                <th scope="row">{{ item.title }}</th>
                <td class="text-center">{{ item.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </accordion>
    </div>
  </div>
</template>

<script>
import CircleChart from "@/components/CircleChart";
import PlayerCard from "@/components/PlayerCard";
import accordion from "@/components/Accordions/Accordion";
import { sort_by } from "@/helpers.js";

export default {
  props: {
    round: { type: Object, required: true }
  },

  components: {
    CircleChart,
    PlayerCard,
    accordion
  },

  data: () => ({
    active_tab: 0,

    include_team_in_player_stats: true,

    include_opponents_in_player_stats: true,

    player_card_open: false,

    player_card_player_id: 0,

    player_card_player: {},

    player_card_team_id: 0,

    stat_is_changing: false,

    stat_filters: [
      {
        title: "Points Per Game",
        abbreviation: "pts",
        individual_stat_key: "points_per_game",
        overall_stat_key: "our_points_per_game"
      },
      {
        title: "Rebounds Per Game",
        abbreviation: "reb",
        individual_stat_key: "rebounds_per_game",
        overall_stat_key: "our_rebounds_per_game"
      },
      {
        title: "Assists Per Game",
        abbreviation: "ast",
        individual_stat_key: "assists_per_game",
        overall_stat_key: "our_assists_per_game"
      },
      {
        title: "Steals Per Game",
        abbreviation: "stl",
        individual_stat_key: "steals_per_game",
        overall_stat_key: "our_steals_per_game"
      },
      {
        title: "Blocks Per Game",
        abbreviation: "blk",
        individual_stat_key: "blocks_per_game",
        overall_stat_key: "our_blocks_per_game"
      }
    ],

    active_stat: null
  }),

  methods: {
    open_player_card(player, team_id) {
      this.player_card_player = player;
      this.player_card_team_id = team_id;
      this.player_card_open = true;
    },

    change_active_stat(stat) {
      this.stat_is_changing = true;
      this.$nextTick(() => {
        this.stat_is_changing = false;
        this.active_stat = stat;
      });
    }
  },

  computed: {
    game() {
      if (!this.round) {
        return null;
      }
      return this.round.game;
    },
    team_stats() {
      if (!this.$root.data || !this.$root.cumestats_overall) {
        return null;
      }

      return this.stat_filters.map(stat => ({
        title: stat.title,
        team: Number(this.$root.cumestats_overall[stat.overall_stat_key]),
        opponent:
          this.round && this.round.opponent_stats.team_stats
            ? Number(
                this.round.opponent_stats.team_stats[stat.overall_stat_key]
              )
            : null
      }));
    },

    opponent_roster_with_stats() {
      if (
        !this.round.opponent_roster.length ||
        !this.round.opponent_stats.individual_stats
      ) {
        return [];
      }

      let roster_without_stats = this.round.opponent_roster.slice();
      let cumestats_without_roster = this.round.opponent_stats.individual_stats.slice();

      let roster_combined = roster_without_stats.map(player => {
        let cumestats_index = cumestats_without_roster.findIndex(
          stats => parseInt(stats.player_roster_bio_id) === player.rp_id
        );
        let matched_cumestats = false;
        if (cumestats_index > -1) {
          matched_cumestats = cumestats_without_roster.splice(
            cumestats_index,
            1
          );
        }
        player.cumestats = matched_cumestats ? matched_cumestats[0] : null;
        player.is_opponent = true;
        player.team =
          this.game && this.game.opponent ? this.game.opponent : null;

        return player;
      });
      return roster_combined;
    },

    sorted_players() {
      if (!this.$root.data) {
        return [];
      }

      let players = [];

      if (this.include_team_in_player_stats && this.$root.roster_with_stats) {
        players = players.concat(this.$root.roster_with_stats);
      }

      if (
        this.include_opponents_in_player_stats &&
        this.opponent_roster_with_stats.length
      ) {
        players = players.concat(this.opponent_roster_with_stats);
      }

      return players
        .filter(player => player.cumestats)
        .sort(
          sort_by(`cumestats.${this.active_stat.individual_stat_key}`, "number")
        )
        .reverse()
        .slice(0, 5);
    }
  },

  created() {
    this.active_stat = this.stat_filters[0];
  }
};
</script>

<style lang="scss" scoped>
.#{$prefix}-game-stats {
  &__title {
    @include flex-item(0 0 auto);
  }
  &__accordions {
    @include flex-item(0 0 auto);
  }
  &__details {
    padding: grid_percent(120);
  }

  &__tabs-container {
    padding: grid_percent(120);
  }

  &__tabs {
    max-height: 100%;
  }

  &__legend-key {
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    overflow: hidden;
    background: var(--primary-background);
    &--opponent {
      background: #d1d1d1;
    }
  }

  &__chart {
    padding: $spacer * 2;
    border-left: solid 1px #eaeaea;
    @include flex-item(1 1 auto);
  }

  &__group {
    @include flex-item(0 1 auto);
    width: 33.333%;
  }
  &__group-title {
    display: none;
  }

  &__table-mobile {
    display: none;
  }

  &__table,
  &__table-title {
    opacity: 1;
    transition: opacity 0.3s 0.2s;
    &.is-changing {
      opacity: 0;
      transition: opacity 0s 0s;
    }
  }

  &__table-indicator-column {
    width: $spacer * 4 + 6;
  }

  &__player-stats {
    thead {
      display: none;
    }
  }

  &__player-stats-headshot {
    width: 184px;
  }
  &__player-stats__stat-filters {
    li {
      &::after {
        border-top: 1px dashed $stroke-on-light;
        content: "";
        display: block;
        height: 1px;
        width: $spacer * 4;
      }
    }

    button {
      @include base-reset();

      border-radius: 50%;
      border: 1px dashed $stroke-on-light;
      color: $text-on-light;
      height: 3rem;
      line-height: 3rem;
      width: 3rem;

      &.is-toggled {
        border-color: $color-black;
        color: $color-black;
      }
    }
  }

  &__player-stats__tr {
    transition: 0.35s;

    &:hover {
      background-color: $color-primary;
      color: $text-on-primary;

      td:nth-child(n + 2) {
        display: none;
      }

      td:last-child {
        display: table-cell;
      }
    }

    th:first-child {
      padding: $spacer !important;
    }

    td:last-child {
      display: none;
    }
  }

  &__player-stats__player-image-container {
    border: 1px dashed $stroke-on-light;
    border-radius: 50%;
    width: 84px;
    height: 84px;
    padding: 12px;

    img {
      border-radius: 50%;
    }
  }

  &__player-stats__player-card-toggle {
    @include base-reset();

    align-items: center;
    display: flex;
    width: 100%;

    span {
      font-size: 1.25rem;
    }

    &::before,
    &::after {
      @include flex-item(1 1 0px);

      border-top: 1px dashed $text-on-primary;
      content: "";
      display: block;
      height: 1px;
    }

    &::after {
      @include flex-item(1 1 $spacer * 4);
    }
  }
}

.slide-fade-enter-active {
  transition: all 0.4s ease;
}
.slide-fade-leave-active {
  transition: all 0.4s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.4s 0.4s, transform 0.4s 0.4s;
}
.fade-enter {
  opacity: 0;
  transform: translateY(10px);
}
.fade-leave {
  display: none;
}

@media (max-width: #{$breakpoint-large}) {
  .sidearm-mm-game-stats {
    &__table-mobile {
      display: table;
    }
    &__table-tablet {
      display: none;
    }
    &__legend {
      img {
        padding: 0 6px;
      }
    }
    &__legend-key {
      display: none;
    }
    &__group {
      width: 100%;
      padding: 0 $spacer;
      border-top: solid 1px #eaeaea;
    }
    &__group-title {
      display: block;
      margin-right: auto;
      padding: $spacer $spacer * 2;
    }
    &__chart {
      @include flex-item(0 1 auto);
      width: 48px;
      padding: 0;
      margin: $spacer * 2 $spacer * 1;
      border: none;
      abbr {
        display: none;
      }
    }
    &__table-header {
      width: calc(100vw - 144px);
    }
    &__table-stat {
      display: inline-block;
      min-width: 72px;
    }
    &__player-stats-headshot {
      width: 132px;
    }
    &__player-stats__player-image-container {
      width: 48px;
      height: 48px;
      padding: 6px;
    }
  }
}

@media (max-width: #{$breakpoint-medium}) {
  .sidearm-mm-game-stats {
    &__player-stats__stat-filters {
      li {
        &::after {
          width: $spacer;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.#{$prefix}-game-stats {
  &__tabs {
    > header {
      @include flex-item(0 0 auto);

      margin-bottom: $spacer * 2 !important;
    }

    > div {
      @include flex-item(1 1 0px);
    }
  }
}
</style>
